// extracted by mini-css-extract-plugin
module.exports = {"header":"Facts_header__2Mqk9","card":"Facts_card__144y2","dummy":"Facts_dummy__3uJBk"};